import axios from 'axios';
import { ApiUrl, Call, ParseGeneralResponse } from 'api/ApiUtils';

function primarySuppliers ({ records }) {
  const data = { primary_suppliers: records };

  return Call(
    'post',
    ApiUrl('/corporate/onboarding/primary_suppliers'),
    { ...data },
    ParseGeneralResponse,
    { responseDataKeys: {} }
  );
}

const getPresignedS3Url = inputKey => (
  Call(
    'post',
    ApiUrl('/corporate/onboarding/presigned_s3_url'),
    {
      key: inputKey
    },
    ParseGeneralResponse,
    {
      responseDataKeys: {
        bucket: 'bucket',
        key: 'key',
        presigned_s3_get_url: 'presigned_s3_get_url',
        presigned_s3_url: 'presigned_s3_url',
      }
    }
  )
);

/**
 * @param {string} fileName
 * @param {string} sourceType
 * @param {number | null} [cloneEventId]
 * @returns {Promise<{ success: boolean, presigned_s3_url: string }>}
 */
const getDocumentParseUrl = (fileName, sourceType, cloneEventId = null) => {
  let path = `/document_parse?key=${encodeURIComponent(fileName)}&source_type=${sourceType}`;
  if (cloneEventId !== null) path += `&source_id=${cloneEventId}`;

  return Call(
    'get',
    ApiUrl(path),
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: {
        presigned_s3_url: 'presigned_s3_url',
      }
    }
  );
};

const uploadDocumentFileUrl = async (uploadUrl, file) => {
  axios.interceptors.request.use(
    config => {
      // Check if the request is a redirect
      if (config.maxRedirects === 0 && config.url !== config.baseURL) {
        // Remove the Authorization header
        // eslint-disable-next-line no-param-reassign
        delete config.headers.Authorization;
      }
      return config;
    },
  );
  return axios.put(uploadUrl, file, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/octet-stream'
    },
    maxRedirects: 0
  });
};

const getTemplateFileInfo = () => (
  Call(
    'get',
    ApiUrl('/corporate/onboarding/template_file_info'),
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: {
        file_info: 'file_info'
      }
    }
  )
);

const Onboard = {
  getDocumentParseUrl,
  getPresignedS3Url,
  getTemplateFileInfo,
  primarySuppliers,
  uploadDocumentFileUrl
};

export default Onboard;
